import React, { useState, useEffect } from 'react';

import UVimage from '../../../images/UvLight.png';
import NailImage from '../../../images/nail care.png';
import Massage from '../../../images/massage.png';
import Pedicure from '../../../images/pedicure.png';
import classnames from 'classnames';
import './index.scss';

const introData = [
	{
		name: 'NEXGEN / SNS. POWDER NAILS',
		content:
			'The Next Generation in Nail Technology! Feel and look natural with NexGen/ SNS Nails! 300+ exciting colors available! No damage to your nails!',
		image: UVimage,
	},
	{
		name: 'Nail Care',
		content:
			'Manicure / French Manicure / Spa Manicure, Pedicure / Aromatic Spa / Lemon Tree Spa, Fill Ins (Gel, Powder, Silk, Acrylic, Fiberglass), Acrylic / UV Gel Set / OPI Gel',
		image: NailImage,
	},
	{
		name: 'Acupressure',
		content:
			'At Amys Nails Spa, our Chinese acupressure therapists use hand techniques to manipulate the various acupressure points and meridian lines throughout the body in order to stimulate and balance blood circulation.',
		image: Massage,
	},
	{
		name: 'Pedicure',
		content:
			'Foot Reflexology is a precious heritage of traditional Chinese medicine.Identifying the generate amazing therapeutic results: Relieves stress and tension, Stimulates circulation of blood, Enhances body immunity, Improves bodys metabolic function.',
		image: Pedicure,
	},
];

const ServiceIntro = () => {
	const [showUp, setShowUp] = useState({
		0: false,
		1: false,
		2: false,
		3: false,
	});

	useEffect(() => {
		const newShowUp = { ...showUp };
		if (window.innerWidth < 769 || document.documentElement.scrollTop > 400) {
			newShowUp[0] = true;
			newShowUp[1] = true;
		}
		if (document.documentElement.scrollTop > 900) {
			newShowUp[2] = true;
			newShowUp[3] = true;
		}
		setShowUp(newShowUp);
	}, [showUp]);

	return (
		<div className='service-intro-wrapper'>
			<div className='service-intro-container'>
				{introData.map((v, i) => (
					<div
						className={classnames('intro-container', {
							showUp: showUp[i],
						})}
					>
						<img src={v.image} alt='img' />
						<div className='intro-content'>
							<h3>{v.name}</h3>
							<p>{v.content}</p>
						</div>
						<p className='mobile'>. . .</p>
					</div>
				))}
			</div>
		</div>
	);
};

export default ServiceIntro;
